"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isNetworkError = isNetworkError;
exports.is500Error = is500Error;
exports.isTimeoutError = isTimeoutError;
exports.isRetryableError = isRetryableError;
exports.defaultRetryHeuristic = defaultRetryHeuristic;
exports.errorToErrorResponse = errorToErrorResponse;

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function isNetworkError(error) {
  if (error && _typeof(error) === 'object') {
    return 'status' in error && 'data' in error;
  }

  return false;
}

function is500Error(error) {
  if (isNetworkError(error)) {
    return Boolean(error.status && error.status >= 500);
  }

  return false;
}

function isTimeoutError(error) {
  if (isNetworkError(error)) {
    return Boolean(error.timeout);
  }

  return false;
}

function isRetryableError(error) {
  return is500Error(error) || isTimeoutError(error);
}

function defaultRetryHeuristic(failureCount, error) {
  if (isRetryableError(error)) {
    return failureCount < 3;
  }

  return false;
}

function errorToErrorResponse(error, defaultMessage, status) {
  return {
    data: (error === null || error === void 0 ? void 0 : error.message) || defaultMessage,
    status: status
  };
}